export const Heading = {
  baseStyle: {
    padding: '32px 10px',
    fontSize: '24px',
    color: 'brand.darkgrey',
    textAlign: 'center',
    fontFamily: 'inherit',
    fontWeight: '300',
  },
};
